import Cookies from 'js-cookie';

export type PayloadWithCsrf<T> = T & {
  csrfmiddlewaretoken: string | undefined;
};

export const getCsrfToken = (): string => {
  return (Cookies.get('csrftoken') ?? getCsrfTokenFromWindow()) as string;
};

const getCsrfTokenFromWindow = () => {
  return (window as { csrf_token?: string })?.csrf_token;
};
